import React from 'react';
import cx from 'classnames';

import {
  IconDropDown,
  Button,
} from 'spindl-shared-components';

import styles from './TableTabNav.module.scss';
import usePresenter from './TableTabNav.presenter';
import getProps from './TableTabNav.props';
import { TableTabNavCombinedProps } from './types';
import TableTabList from '../../molecules/TableTabList';


const TableTabNav: React.FC<TableTabNavCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    iconDropDown,
    tableTabList,
    tableLeftButton,
    tableRightButton,
    tableTabListWrapperRef, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`tableTabNav${variantName}`];

  let componentView;

  switch (variantName) {
    case 'NoTableOverflow': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.dropDownButtonContainer, classes?.dropDownButtonContainer)}>
            <IconDropDown
              className={cx(styles.iconDropDown, classes?.iconDropDown)}
              {...internalProps.iconDropDown}
              {...iconDropDown}
            />
          </div>
          <div
            className={cx(styles.tableContainer, classes?.tableContainer)}
            ref={tableTabListWrapperRef}
          >
            <TableTabList
              className={cx(styles.tableTabList, classes?.tableTabList)}
              {...internalProps.tableTabList}
              {...tableTabList}
            />
          </div>
        </div>
      );
      break;
    }
    case 'TableOverflow': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.dropDownButtonContainer, classes?.dropDownButtonContainer)}>
            <IconDropDown
              className={cx(styles.iconDropDown, classes?.iconDropDown)}
              {...internalProps.iconDropDown}
              {...iconDropDown}
            />
          </div>
          <div
            className={cx(styles.tableContainer, classes?.tableContainer)}
            ref={tableTabListWrapperRef}
          >
            <Button
              className={cx(styles.tableLeftButton, classes?.tableLeftButton)}
              {...internalProps.tableLeftButton}
              {...tableLeftButton}
            />
            <TableTabList
              className={cx(styles.tableTabList, classes?.tableTabList)}
              {...internalProps.tableTabList}
              {...tableTabList}
            />
            <Button
              className={cx(styles.tableRightButton, classes?.tableRightButton)}
              {...internalProps.tableRightButton}
              {...tableRightButton}
            />
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default TableTabNav;
